import { selectUserRole, selectNewUserRole } from 'src/app/user'
import { useGetUserContextQuery } from 'src/app/zoomSdkQueries'
import FullScreenSpinner from 'src/components/FullScreenSpinner'
import {
  useAppSelector,
  useRevisitHome,
  useOnMyUserContextChange,
} from 'src/hooks'
import HostNavigation from '../components/Navigation/HostNavigation'
import ParticipantSession from '../components/session/ParticipantSession'
import HostChangeMidMeeting from './HostChangeMidMeeting'

function Home() {
  const { isLoading } = useGetUserContextQuery('getUserContext')
  const role = useAppSelector(selectUserRole)
  const newRole = useAppSelector(selectNewUserRole)
  useOnMyUserContextChange()
  const needsHomeRevisit = useRevisitHome()

  return (
    <>
      {(isLoading && !role) || needsHomeRevisit ? (
        <FullScreenSpinner />
      ) : newRole ? (
        <HostChangeMidMeeting role={newRole} />
      ) : role === 'host' ? (
        <HostNavigation />
      ) : (
        <ParticipantSession />
      )}
    </>
  )
}

export default Home
